var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentMagentoClient } from "@jti/magento";
import { redirectToCartPage } from "../../utils/cartHelpers";
const fetchOrderDeclaration = (isFreeTrial) => createAsyncThunk(isFreeTrial ? "freeTrialOrder/fetchOrder" : "order/fetchOrder", (orderId_1, _a) => __awaiter(void 0, [orderId_1, _a], void 0, function* (orderId, { rejectWithValue }) {
    try {
        const order = yield getCurrentMagentoClient(isFreeTrial).getCustomerOrder(orderId);
        return order;
    }
    catch (error) {
        redirectToCartPage();
        return rejectWithValue(error);
    }
}));
export const fetchOrder = fetchOrderDeclaration(false);
export const fetchFreeTrialOrder = fetchOrderDeclaration(true);
//# sourceMappingURL=fetchOrder.js.map